import React from 'react'
import { withStyles } from '@mui/styles'
import { Box, Typography, Grid, Button } from '@mui/material'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { privateAreaNavigatioNGuidePanelStyles } from './private-area-navigation-guide-panel.style'
import {
  TABLET_IMG,
  privateAreaGuideArray,
  privateAreaGuideArrayPrescriptor,
} from '../../constants/privateAreaNavigationGuide.constants'

// NEVO-439 - Limitar ACVC post portal único: URL pendiente de definición por negocio.
const COMPLETE_GUIDE_URL = '#'

export const PrivateAreaNavigationGuidePanel = withStyles(privateAreaNavigatioNGuidePanelStyles)(({
  classes,
}) => {
  const intl = useIntl()
  const isPrescriptor = useSelector((state) => state.global.role === 'administrador_prescriptor')

  const openLinkHandler = (link) => {
    window.open(link)
  }

  const listToRender = isPrescriptor ? privateAreaGuideArrayPrescriptor : privateAreaGuideArray

  const handlePrintList = () =>
    listToRender.map((item, i) => {
      return (
        <Grid key={i} size={{ lg: 4 }} className={classes.guideItem}>
          <Box display="flex" flexDirection="column" mb={2}>
            <Typography style={{ fontWeight: 'bold' }} variant="h4" color="primary">
              {intl.formatMessage({ id: `pages.privateAreaNavigationGuide.${item.title}` })}
            </Typography>
            <Typography style={{ fontSize: '1.5em' }} color="primary">
              {intl.formatMessage({ id: `pages.privateAreaNavigationGuide.${item.description}` })}
            </Typography>
          </Box>
          <Box width="100%">
            <Button
              onClick={() => openLinkHandler(item.url)}
              color="primary"
              style={{ fontSize: '1.2em', padding: '0em 2em', marginBottom: '1em' }}
              variant="contained"
            >
              {intl.formatMessage({ id: 'pages.privateAreaNavigationGuide.checkGuide' })}
            </Button>
            {item.extraUrl && (
              <Button
                onClick={() => openLinkHandler(item.extraUrl)}
                color="primary"
                style={{
                  fontSize: '1.2em',
                  padding: '0em 2em',
                  marginBottom: '1em',
                  marginLeft: '0.5em',
                }}
                variant="contained"
              >
                {intl.formatMessage({ id: 'pages.privateAreaNavigationGuide.checkGuide' })}
              </Button>
            )}
            <Box className={classes.guideItemSeparator}></Box>
          </Box>
        </Grid>
      )
    })

  return (
    <Box
      display="flex"
      bgcolor="rgb(255,255,255)"
      flexDirection="column"
      alignItems="center"
      borderRadius={20}
      mt={2}
      mb={2}
      style={{ padding: '4em 5em' }}
    >
      <Grid container className={classes.headTitleContainer}>
        <Grid style={{ display: 'flex', justifyContent: 'center' }} size={{ lg: 4 }}>
          <Box>
            <Typography style={{ fontWeight: 'bold' }} variant="h3" color="primary">
              {intl.formatMessage({ id: 'pages.privateAreaNavigationGuide.headLine' })}
            </Typography>

            <Box mt={5}>
              <Typography variant="h3" color="primary">
                {intl.formatMessage({ id: 'pages.privateAreaNavigationGuide.subHeadLine' })}
              </Typography>
            </Box>
          </Box>
        </Grid>

        <Grid style={{ display: 'flex', justifyContent: 'center' }} size={{ lg: 4 }}>
          <Box mt={2}>
            <img className={classes.img} src={TABLET_IMG} width="300" alt="" />
          </Box>
        </Grid>

        <Grid style={{ display: 'flex', justifyContent: 'center' }} size={{ lg: 4 }}>
          {/* NEVO-439 - Limitar ACVC post portal único: se unifica el botón principal en
          "Guía completa". URL pendiente de definición por negocio. */}
          <Button
            className={classes.mainButton}
            variant="contained"
            onClick={() => openLinkHandler(COMPLETE_GUIDE_URL)}
          >
            {intl.formatMessage({ id: 'pages.privateAreaNavigationGuide.completeGuide' })}
          </Button>
        </Grid>
      </Grid>

      <Box mt={4} mb={4} alignSelf="start">
        <Typography variant="h3" color="primary" style={{ fontWeight: 'bold' }}>
          {!isPrescriptor &&
            intl.formatMessage({ id: 'pages.privateAreaNavigationGuide.guidesByThemes' })}
        </Typography>
      </Box>
      <Grid spacing={5} container alignItems="flex-start">
        {!isPrescriptor && handlePrintList()}
      </Grid>
    </Box>
  )
})
